import Vue from 'vue'
import Vuex from 'vuex'
import ActivityCentre from './VuexModules/ActivityCentre'
import ApiUser from './VuexModules/ApiUser.js'
import AuthorizationsModule from './VuexModules/AuthorizationsModule.js'
import BranchModule from './VuexModules/BranchModule'
import BrandModule from './VuexModules/BrandModule'
import CheckerModule from './VuexModules/CheckerModule'
import DashboardModule from './VuexModules/DashboardModule.js'
import Doors from './VuexModules/DoorModule'
import EmployeeModule from './VuexModules/EmployeeModule'
import GgModule from './VuexModules/GgModule'
import GlobalPolls from './VuexModules/GlobalPolls'
import Levels from './VuexModules/LevelModule'
import LoginModule from './VuexModules/LoginModule'
import NoticeModule from './VuexModules/NoticeModule'
import PaymentConceptModule from './VuexModules/PaymentConceptModule'
import PaymentModule from './VuexModules/PaymentModule'
import PollModule from './VuexModules/PollsModule'
import ReportsModule from './VuexModules/ReportsModule'
import RequestModule from './VuexModules/RequestModules'
import RoundModule from './VuexModules/RoundModule.js'
import StatisticsModule from './VuexModules/StatisticsModule'
import StudentModule from './VuexModules/StudentModule'
import SubgroupModule from './VuexModules/SubgroupsModule'
import TransportModule from './VuexModules/TransportModule.js'
import TutorModule from './VuexModules/TutorModule'
import UdModule from './VuexModules/UdModule'
import VisitsModule from './VuexModules/VisitsModule'
import WebRole from './VuexModules/WebRoleModule'

import axios from 'axios'
import ClassroomModule from './VuexModules/ClassroomModule'
import HolidaysModule from './VuexModules/HolidaysModule'
import WorkshopModule from './VuexModules/WorkshopModule'

import CollegesModule from './VuexModules/CollegesModule'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'es',
    isSuperAdmin: JSON.parse(localStorage.getItem('isSA')) || false,
    status: '',
    token: localStorage.getItem('token') || '',
    firebaseToken: localStorage.getItem('fToken') || '',
    user: {
      branch: {
        name: '',
      },
    },
    user_sa: {},
    branch: {},
    schoolStats: {},
    countActivities: 0,
    doors: [],
    webRoles: [],
    catalogs: [],
    menu: [
      {
        nombre: 'Salidas',
        name: 'panel.visor',
        descriptiion: 'panel.visorDesc',
        route: 'visor',
        activo: false,
        icon: 'dvr',
        iconSelected: 'dvr',
        desc: 'Visualiza en tiempo real las transacciones de los alumnos',
        iconImage: 'SKLB-Entregas.png',
        permit: 'WATCH_VISOR',
      },
      {
        nombre: 'Configuración',
        name: 'panel.configuration',
        descriptiion: 'panel.configDesc',
        route: 'configuration',
        activo: false,
        icon: 'settings',
        iconSelected: 'settings',
        desc: 'Administra la configuración',
        iconImage: 'SKLB-Configuracion.png',
        permit: 'WATCH_SETTINGS',
      },
      {
        nombre: 'Niveles',
        name: 'panel.levels',
        descriptiion: 'panel.levelsDesc',
        route: 'levels',
        activo: false,
        icon: 'flag',
        iconSelected: 'flag',
        desc: 'Añade y administra los diferentes niveles, grados y grupos',
        iconImage: 'SKLB-Niveles.png',
        permit: 'WATCH_LEVELS',
      },
      {
        name: 'panel.extraLevels',
        descriptiion: 'panel.extraLevelsDesc',
        route: 'registers',
        activo: false,
        icon: 'sports_soccer',
        iconSelected: 'sports_soccer',
        iconImage: 'SKLB-Registros.png',
        permit: 'WATCH_EXTRAS',
      },
      {
        nombre: 'Grupos',
        name: 'panel.subgrupos',
        descriptiion: 'panel.subgruposDesc',
        route: 'subgroups',
        activo: false,
        icon: 'groups',
        iconSelected: 'groups',
        desc: 'Crea y administra los grupos y horarios para el regreso a clases por bloques',
        iconImage: 'SKLB-Grupos.png',
        permit: 'WATCH_SUBGROUPS',
      },
      {
        nombre: 'Colaboradores',
        name: 'panel.employees',
        descriptiion: 'panel.empDesc',
        route: 'employee',
        activo: false,
        icon: 'work',
        iconSelected: 'work',
        desc: 'Añade y administra a todos los colaboradores',
        iconImage: 'SKLB-Colabordores.png',
        permit: 'WATCH_COLAB',
      },
      {
        nombre: 'Alumnos',
        name: 'panel.students',
        descriptiion: 'panel.stdDesc',
        route: 'students',
        activo: false,
        icon: 'school',
        iconSelected: 'school',
        desc: 'Añade y administra todos los alumnos',
        iconImage: 'SKLB-Alumnos.png',
        permit: 'WATCH_STUDENTS',
      },
      {
        nombre: 'Tutores',
        name: 'panel.parents',
        descriptiion: 'panel.parDesc',
        route: 'parents',
        activo: false,
        icon: 'person',
        iconSelected: 'person',
        desc: 'Añade y administra todos los padres de familia',
        iconImage: 'SKLB-Tutores.png',
        permit: 'WATCH_PARENTS',
      },
      {
        nombre: 'Dispositivos',
        name: 'panel.devices',
        descriptiion: 'panel.devDesc',
        route: 'devices',
        activo: false,
        icon: 'phone_iphone',
        iconSelected: 'phone_iphone',
        desc: 'Añade y administra todos los dispositivos',
        iconImage: 'SKLB-Dispositivos.png',
        permit: 'WATCH_DEVICES',
      },
      {
        nombre: 'Reportes',
        name: 'panel.reports',
        descriptiion: 'panel.repoDesc',
        route: 'reports',
        activo: false,
        icon: 'show_chart',
        iconSelected: 'show_chart',
        desc: 'Visualiza y descarga los diferentes reportes diarios',
        iconImage: 'SKLB-Reportes.png',
        permit: 'WATCH_REPORTS',
      },
      {
        nombre: 'Rondas',
        name: 'panel.rounds',
        descriptiion: 'panel.rndDesc',
        route: 'rounds',
        activo: false,
        icon: 'sync',
        iconSelected: 'sync',
        desc: 'Visualiza, administra y gestiona las rondas de los tutores',
        iconImage: 'SKLB-Ronda.png',
        permit: 'WATCH_ROUNDS',
      },
      {
        nombre: 'Comunidad',
        name: 'panel.comunity',
        descriptiion: 'panel.comunDesc',
        route: 'notices',
        activo: false,
        icon: 'library_books',
        iconSelected: 'library_books',
        desc: 'Crea y administra eventos, avisos, reportes y permisos',
        iconImage: 'SKLB-Comunidad.png',
        permit: 'WATCH_NOTICE',
      },
      {
        nombre: 'Estadísticas',
        name: 'panel.statistics',
        descriptiion: 'panel.statDesc',
        route: 'statistics',
        activo: false,
        icon: 'insert_chart',
        iconSelected: 'insert_chart',
        desc: 'Visualiza las estadísticas del proceso de entrega de los alumnos',
        iconImage: 'SKLB-Estadisticas.png',
        permit: 'WATCH_STATS',
      },
      // {
      //   nombre: "Pagos",
      //   name: "panel.pagos",
      //   descriptiion: "panel.pagosDesc",
      //   route: "payments",
      //   activo: false,
      //   icon: "monetization_on",
      //   iconSelected: "monetization_on",
      //   desc: "Administra y emite pagos de diferentes conceptos",
      //   iconImage: "SKLB-Pagos.png",
      //   permit: "WATCH_PAYMENTS"
      // },
      {
        nombre: 'Encuestas',
        name: 'panel.encuestas',
        descriptiion: 'panel.encuestasDesc',
        route: 'polls',
        activo: false,
        icon: 'equalizer',
        iconSelected: 'equalizer',
        desc: 'Visualiza, administra, descarga y crea nuevas encuestas',
        iconImage: 'SKLB-Encuestas.png',
        permit: 'WATCH_POLLS',
      },
      {
        nombre: 'Citas',
        name: 'panel.citas',
        descriptiion: 'panel.citasDesc',
        route: 'visits',
        activo: false,
        icon: 'badge',
        iconSelected: 'badge',
        desc: 'Visualiza, administra, descarga y crea nuevas citas',
        iconImage: 'SKLB-Citas.png',
        permit: 'WATCH_VISITS',
      },
      //Actualizaciones
      {
        nombre: 'Actualizaciones',
        name: 'panel.update',
        descriptiion: 'panel.updateDesc',
        route: 'update',
        activo: false,
        icon: 'update',
        iconSelected: 'update',
        desc: 'Visualiza las nuevas actualizaciones de skolable',
        iconImage: 'SKLB-Updates.png',
        permit: 'WATCH_VISOR',
      },
      {
        nombre: 'Horarios de colaboradores',
        name: 'panel.schedule',
        descriptiion: 'panel.scheduleDes',
        route: 'checker',
        activo: false,
        icon: 'schedule',
        iconSelected: 'schedule',
        desc: 'Gestiona horarios para tus colaboradores y visualiza los reportes de asistencia',
        iconImage: 'SKLB-HorarioColab.png',
        permit: 'WATCH_SCHEDULE_COLLABORATOR',
      },
      {
        nombre: 'Pases de salida',
        name: 'panel.authorizations',
        descriptiion: 'panel.authorizationsDesc',
        route: 'authorizations',
        activo: false,
        icon: require('@/assets/icons/autorizar.svg'),
        iconSelected: 'schedule',
        iconImage: 'autorizar (3) 1.png',
        // CHANGE WHEN API IS READY
        permit: 'WATCH_EXTRAS',
      },
      {
        nombre: 'Transporte Escolar',
        name: 'panel.schoolTransportation',
        descriptiion: 'panel.schoolTransportationDescription',
        route: 'school_transportation',
        activo: false,
        icon: 'directions_bus',
        iconSelected: 'directions_bus',
        iconImage: 'bus.png',
        // CHANGE WHEN API IS READY
        permit: 'WATCH_TRANSPORT_ROUTE',
      },
    ],
    SAMenu: [
      {
        route: 'colleges',
        name: 'SAPanel.colleges',
        description: 'SAPanel.collegesDesc',
        activo: false,
        icon: 'dvr',
        iconSelected: 'dvr',
        iconImage: 'sa_colleges_icon.png',
        // permit: "WATCH_VISOR",
        isDummy: false,
      },
      {
        route: 'collaborators',
        name: 'SAPanel.collaborators',
        description: 'SAPanel.collaboratorsDesc',
        activo: false,
        icon: 'dvr',
        iconSelected: 'dvr',
        description: 'Añade y administra a todos los colaboradores',
        iconImage: 'SKLB-Colabordores.png',
        // permit: "WATCH_VISOR",
        isDummy: false,
      },
      {
        nombre: 'Colegios',
        name: 'SAPanel.colleges',
        descriptiion: 'panel.visorDesc',
        route: 'colleges',
        activo: false,
        icon: 'dvr',
        iconSelected: 'dvr',
        description: 'Administra el colegio y sus licencias',
        iconImage: 'sa_colleges_icon.png',
        // permit: "WATCH_VISOR",
        isDummy: true,
      },
      {
        nombre: 'Colegios',
        name: 'SAPanel.colleges',
        descriptiion: 'panel.visorDesc',
        route: 'colleges',
        activo: false,
        icon: 'dvr',
        iconSelected: 'dvr',
        description: 'Administra el colegio y sus licencias',
        iconImage: 'sa_colleges_icon.png',
        // permit: "WATCH_VISOR",
        isDummy: true,
      },
      {
        nombre: 'Colegios',
        name: 'SAPanel.colleges',
        descriptiion: 'panel.visorDesc',
        route: 'colleges',
        activo: false,
        icon: 'dvr',
        iconSelected: 'dvr',
        description: 'Administra el colegio y sus licencias',
        iconImage: 'sa_colleges_icon.png',
        // permit: "WATCH_VISOR",
        isDummy: true,
      },
    ],
    error: {
      code: '',
      message: '',
    },
    modal: false,
    isEmail: null,
    collegeSelect: {},
    msgDisableCollege: {},
    brandTZ: {},
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, payload) {
      state.status = 'success'
      state.token = payload.token
      state.user = payload.user
      state.isSuperAdmin = payload.isSuperAdmin
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.isSuperAdmin = false
    },
    updatePartialUser(state, payload) {
      if (state.user != null) {
        state.user.id = payload.user.id
        state.user.mail = payload.user.mail
        state.user.branch = payload.user.branch
      } else {
        state.user = {
          id: payload.user.id,
          mail: payload.user.mail,
          branch: payload.user.branch,
          webRole: {},
          catalogs: {},
        }
      }
    },
    updateUser(state, payload) {
      state.user = payload.user
    },
    updateBranch(state, payload) {
      state.branch = payload.branch
    },
    updateUserSA(state, payload) {
      state.user_sa = payload.user_sa
    },
    updateImageBranch(state, payload) {
      state.branch.img = payload.image
    },
    updateSchoolStats(state, payload) {
      state.schoolStats = payload.schoolStats
    },
    updateCountActivities(state, payload) {
      state.countActivities = payload.count
    },
    resetCountActivities(state) {
      state.countActivities = 0
    },
    updateDoors(state, payload) {
      state.doors = payload.doors
    },
    updateDoor(state, payload) {
      for (var d in state.doors) {
        if (state.doors[d].id == payload.door.id) {
          state.doors[d].doorName = payload.door.doorName
          state.doors[d].type = payload.door.type
          state.doors[d].street = payload.door.street
          break
        }
      }
    },
    addDoor(state, payload) {
      state.doors.unshift(payload.door)
    },
    deleteDoor(state, payload) {
      for (var d in state.doors) {
        if (state.doors[d].id == payload.door.id) {
          state.doors.splice(d, 1)
          break
        }
      }
    },
    throwError(state, payload) {
      state.error = payload.error
    },
    updateWebRoles(state, payload) {
      state.webRoles = payload.webRoles
    },
    updateCatalogs(state, payload) {
      state.catalogs = payload.catalogs
    },
    addWebRole(state, payload) {
      state.webRoles.push(payload.webRole)
    },
    updateFirebaseToken(state, payload) {
      state.firebaseToken = payload.token
    },
    _setToggleModalPreview(state) {
      state.modal = !state.modal
    },
    _setIsEMail(state, isEmail) {
      state.isEmail = isEmail
    },
    _setCollege(state, collegeSelect) {
      state.collegeSelect = collegeSelect
    },
    _setMsgDisableCollege(state, msgDisableCollege) {
      state.msgDisableCollege = msgDisableCollege
    },
    _setBrandTZ(state, brandTZ) {
      state.brandTZ = brandTZ
    },
  },
  getters: {
    getLang: (state) => state.lang,
    isSuperAdmin: (state) => state.isSuperAdmin,
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    getToken: (state) => {
      return state.token
    },
    getMenuItems: (state) => {
      if (state.isSuperAdmin === true) {
        return state.SAMenu
      }
      return state.menu
    },
    getUser: (state) => {
      return state.user
    },
    getUserSA: (state) => {
      return state.user_sa
    },
    getBranch: (state) => {
      return state.branch
    },
    getSchoolStats: (state) => {
      return state.schoolStats
    },
    getCountActivities: (state) => {
      return state.countActivities
    },
    getDoors: (state) => {
      return state.doors
    },
    getError: (state) => {
      return state.error
    },
    getWebRoles: (state) => {
      return state.webRoles
    },
    getCatalogs: (state) => {
      return state.catalogs
    },
    getStatusToggleModalPreview: (state) => {
      return state.modal
    },
    getStatusIsEmail: (state) => {
      return state.isEmail
    },
    getCollegeSelect: (state) => {
      return state.collegeSelect
    },
    getMsgDisableCollege: (state) => {
      return state.msgDisableCollege
    },
    getBrandTZ: (state) => {
      return state.brandTZ
    },
  },
  modules: {
    apiUser: ApiUser,
    dashboard: DashboardModule,
    authorizations: AuthorizationsModule,
    login: LoginModule,
    branch: BranchModule,
    employee: EmployeeModule,
    activity: ActivityCentre,
    doors: Doors,
    webRole: WebRole,
    level: Levels,
    request: RequestModule,
    student: StudentModule,
    colleges: CollegesModule,
    gg: GgModule,
    tutor: TutorModule,
    ud: UdModule,
    notice: NoticeModule,
    reports: ReportsModule,
    stats: StatisticsModule,
    brand: BrandModule,
    round: RoundModule,
    payments: PaymentModule,
    paymentConcepts: PaymentConceptModule,
    polls: PollModule,
    subgroups: SubgroupModule,
    visits: VisitsModule,
    globalPolls: GlobalPolls,
    workshop: WorkshopModule,
    holiday: HolidaysModule,
    classRoom: ClassroomModule,
    checker: CheckerModule,
    transport: TransportModule,
  },
  actions: {
    getIsEmail(context, isEmail) {
      context.commit('_setIsEMail', isEmail)
    },
    timeZoneAPI({ getters }, obj) {
      return new Promise((resolve, reject) => {
        delete axios.defaults.headers.common['Authorization']
        delete axios.defaults.headers.common['Access-Control-Allow-Origin']
        delete axios.defaults.headers.common['userType']
        delete axios.defaults.headers.common['environment']
        delete axios.defaults.headers.common['gadgetType']
        axios({
          url:
            'https://maps.googleapis.com/maps/api/timezone/json?location=' +
            obj.latitude +
            ',' +
            obj.longitude +
            '&timestamp=1331161200&key=AIzaSyCT0-TRG6EiG8gRKj7syFaJBt9wsY-en9U',
          headers: {},
          method: 'GET',
        })
          .then((response) => {
            axios.defaults.headers.common['Authorization'] = getters.getToken
            axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
            axios.defaults.headers.common['userType'] = 'W'
            axios.defaults.headers.common['environment'] =
              process.env.VUE_APP_ENVIRONMENT
            axios.defaults.headers.common['gadgetType'] = 'A'
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getErrors(response) {
      if (response.ok) {
        switch (response.body.code) {
          case 400:
            break
          case 401:
            break
          case 500:
            break
          case 1022:
            break
          case 1025:
            break
          case 1009:
            break
          case 1017:
            break
          case 1015:
            break
          default:
            break
        }
      } else {
        // Not Handled Errros
        switch (response.status) {
          case 401:
            break
          case 500:
            break
          default:
            break
        }
      }
    },
    getToggleModalPreview(context) {
      context.commit('_setToggleModalPreview')
    },
    getCollege(context, college) {
      context.commit('_setCollege', college)
    },
    getMsgDisableCollege(context, msg) {
      context.commit('_setMsgDisableCollege', msg)
    },
    getBrandTZ(context, brandTZ) {
      context.commit('_setBrandTZ', brandTZ)
    },
  },
})
